import React from 'react';

const StreamingCursor: React.FC = () => (
  <span
    style={{
      display: 'inline-block',
      width: '2px',
      height: '1em',
      backgroundColor: 'currentColor',
      marginLeft: '1px',
      verticalAlign: 'text-bottom',
      animation: 'addapt-cursor-blink 1s step-end infinite',
    }}
    aria-hidden="true"
  >
    <style>{`
      @keyframes addapt-cursor-blink {
        0%, 100% { opacity: 1; }
        50% { opacity: 0; }
      }
    `}</style>
  </span>
);

export default StreamingCursor;
